import React from "react";

const Spinner: React.FC = () => {
  return (
    <div className="text-center">
      <div className="lds-roller mx-auto"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    </div>
  )
}

export default Spinner;